import React, { useState } from 'react';
import i18next from 'i18next';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { createTask } from 'redux/applications/actions';
import TaskModal from './Modal';

const CreateTaskButton = () => {
  const { id } = useParams();
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();

  const toggleModal = () => {
    setVisible(!visible);
  };

  const onOk = (value) => dispatch(createTask({ id, data: value }));

  return (
    <>
      <Button
        className="add-button"
        onClick={toggleModal}
        icon={<PlusOutlined />}
      >
        {i18next.t('button.create')}
      </Button>
      <TaskModal
        visible={visible}
        onOk={onOk}
        onCancel={toggleModal}
        toggleModal={toggleModal}
        okText="button.create"
      />
    </>
  );
};

export default CreateTaskButton;
